'use client';

import {useEffect, useRef} from 'react';
import clsx from 'clsx';

import type {ContainerSpacing} from '@/modules/foundation/components/container';
import {Container} from '@/modules/foundation/components/container';

type Props = {
	spacingBottom?: ContainerSpacing;
	spacingTop?: ContainerSpacing;
};

export const CookieReport = ({spacingBottom, spacingTop}: Props) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (containerRef.current) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = `${process.env.NEXT_PUBLIC_COOKIE_SCRIPT_REPORT_SRC}`;
			script.setAttribute('data-cookiescriptreport', 'report');

			containerRef.current.appendChild(script);
		}
	}, []);

	return (
		<Container spacingBottom={spacingBottom} spacingTop={spacingTop}>
			<div>
				{process.env.NEXT_PUBLIC_COOKIE_SCRIPT_REPORT_SRC ? (
					<>
						{process.env.NODE_ENV !== 'development' ? (
							<div className={clsx('overflow-x-auto')}>
								<div ref={containerRef} />
							</div>
						) : (
							<div
								className={clsx(
									'bg-yellow-50',
									'p-4',
									'text-center',
									'text-yellow-700',
									'rounded-lg',
									'border',
									'border-yellow-700',
									'font-bold',
								)}
							>
								<p>Development mode does not load the CookieScript report!</p>
							</div>
						)}
					</>
				) : (
					<div
						className={clsx(
							'bg-red-50',
							'p-4',
							'text-center',
							'text-red-700',
							'rounded-lg',
							'border',
							'border-red-700',
							'font-bold',
						)}
					>
						<p>No CookieScript report is set up for this site!</p>
					</div>
				)}
			</div>
		</Container>
	);
};
